import React, {useEffect, useState} from 'react';
import careersActions from "../store/actions/careers";
import {useDispatch, useSelector} from "react-redux";
import "./jobInfo.scss";
import ModalApplyNow from "../components/Careers/ModalApplyNow";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import axios from "axios";
import {
    EmailShareButton,
    FacebookShareButton,
    HatenaShareButton,
    InstapaperShareButton,
    LineShareButton,
    LinkedinShareButton,
    LivejournalShareButton,
    MailruShareButton,
    OKShareButton,
    PinterestShareButton,
    PocketShareButton,
    RedditShareButton,
    TelegramShareButton,
    TumblrShareButton,
    TwitterShareButton,
    ViberShareButton,
    VKShareButton,
    WhatsappShareButton,
    WorkplaceShareButton
} from "react-share";




const JobInfo = () => {
    const careersStore = useSelector((store) => store.careersStore);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const id = useParams();
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        dispatch(careersActions.fetchJob(id))
    }, []);

    const prev = useLocation().state

    const goBack = () => {
        if (prev === 'information'){
            navigate(-1)
        } else {
            navigate('/careers')
        }
    }

    const applyJob = () => {
        dispatch(careersActions.setFormJobPosition(careersStore.job.position));
        dispatch(careersActions.setModalOpen(true));
        document.getElementsByTagName('body')[0].classList.add('modal-open');
    }

    let copiedTimeout;
    const copyLink = () => {
        clearTimeout(copiedTimeout)
        setCopied(true);
        copiedTimeout = setTimeout(() => {
            setCopied(false);
        }, 2000)
    }

    const modalSuccessClose = () => {
        dispatch(careersActions.setModalSuccessOpen(false));
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }

    return (
        <div className={`careers ${careersStore.isLoading ? 'is-loading' : ''}`}>
            <div className="careers-spinner"/>
            {careersStore.job && (
                <div>
                    {careersStore.modalOpen &&
                    <ModalApplyNow/>
                    }
                    <div className="job-info">
                        <div className="container">
                            <button type="button" className="job-info__btn-back" onClick={() => {goBack()}}>
                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/arrow-angled.svg`} alt="arrow"/>
                                <span>All job openings</span>
                            </button>
                            <div className="job-info__row">
                                <div className="job-info__content">
                                    <div className="job-info__heading">
                                        <div className="job-info__heading-info">
                                            <div className="job-info__title">{careersStore.job.position}</div>
                                            <div className="job-info__description">
                                                <div className="job-info__description-item">
                                                    {careersStore.job.department.name}
                                                </div>
                                                <div className="job-info__description-item">
                                                    {careersStore.job.location}
                                                </div>
                                                <div className="job-info__description-item">
                                                    {careersStore.job.employmentType.name}
                                                </div>
                                            </div>
                                            {careersStore.job.wage && (
                                                <div className="job-info__wage">
                                                    <span>{careersStore.job.wage}</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="job-info__apply mobile">
                                            <button type="button" className="job-info__apply-btn button-gradient" onClick={() => applyJob()}>Apply now</button>
                                            <div className="job-info__socials">
                                                <p className="job-info__socials-title">Share job</p>
                                                <div className="job-info__socials-list">
                                                    <TwitterShareButton url={window.location.href}>
                                                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/ic-twitter.svg`} alt="twitter"/>
                                                    </TwitterShareButton>
                                                    <FacebookShareButton url={window.location.href}>
                                                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/ic-facebook.svg`} alt="facebook"/>
                                                    </FacebookShareButton>
                                                    <LinkedinShareButton url={window.location.href}>
                                                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/ic-linkedin.svg`} alt="linkedin"/>
                                                    </LinkedinShareButton>
                                                    <div className="job-info__copy">
                                                        <CopyToClipboard text={window.location.href}
                                                                         onCopy={() => copyLink()}>
                                                            <button>
                                                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/share.svg`} alt="share"/>
                                                            </button>
                                                        </CopyToClipboard>
                                                        <span className={copied ? 'show' : ''}>Copied</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="job-info__content">
                                        <div className="job-info__content--title">Job Description</div>
                                        {careersStore.job.summary && (
                                            <div className="job-info__summary">
                                                <div className="job-info__content--subtitle">Overview</div>
                                                <div dangerouslySetInnerHTML={{ __html: careersStore.job.summary }}/>
                                            </div>
                                        )}
                                        {careersStore.job.duties && (
                                            <div className="job-info__duties">
                                                <div className="job-info__content--subtitle">Responsibilities</div>
                                                <div dangerouslySetInnerHTML={{ __html: careersStore.job.duties }}/>
                                            </div>
                                        )}
                                        {careersStore.job.benefits && (
                                            <div className="job-info__benefits">
                                                <div className="job-info__content--subtitle">Benefits</div>
                                                <div dangerouslySetInnerHTML={{ __html: careersStore.job.benefits }}/>
                                            </div>
                                        )}
                                        {careersStore.job.requirements && (
                                            <div className="job-info__requirements">
                                                <div className="job-info__content--subtitle">Qualifications</div>
                                                <div dangerouslySetInnerHTML={{ __html: careersStore.job.requirements }}/>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="job-info__apply">
                                    { careersStore.job.url ? (
                                        <a href={careersStore.job.url} target="_blank" className="job-info__apply-btn button-gradient">Apply now</a>
                                    ) : (
                                        <button type="button" className="job-info__apply-btn button-gradient" onClick={() => {applyJob()}}>Apply now</button>
                                    )}
                                    <div className="job-info__socials">
                                        <p className="job-info__socials-title">Share job</p>
                                        <div className="job-info__socials-list">
                                            <TwitterShareButton url={window.location.href}>
                                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/ic-twitter.svg`} alt="twitter"/>
                                            </TwitterShareButton>
                                            <FacebookShareButton url={window.location.href}>
                                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/ic-facebook.svg`} alt="facebook"/>
                                            </FacebookShareButton>
                                            <LinkedinShareButton url={window.location.href}>
                                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/ic-linkedin.svg`} alt="linkedin"/>
                                            </LinkedinShareButton>
                                            <div className="job-info__copy">
                                                <CopyToClipboard text={window.location.href}
                                                                 onCopy={() => copyLink()}>
                                                    <button>
                                                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/share.svg`} alt="share"/>
                                                    </button>
                                                </CopyToClipboard>
                                                <span className={copied ? 'show' : ''}>Copied</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="job-info__banner">
                            <div className="container">
                                <div className="left-block">
                                    <div className="title">Let's grow together</div>
                                    { careersStore.job.url ? (
                                        <a href={careersStore.job.url} target="_blank" className="button button-gradient">Apply for this job</a>
                                    ) : (
                                        <button type="button" className="button button-gradient" onClick={() => {applyJob()}}>Apply for this Job</button>
                                    )}
                                </div>
                                <div className="right-block">
                                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/notebook.png`} alt="find-agent" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className={`modal modal-success ${careersStore.modalSuccessOpen ? 'open' : ''}`}>
                <div className="modal-overlay" onClick={() => modalSuccessClose()}/>
                <div className="modal-block">
                    <button type="button" className="modal-close" onClick={() => modalSuccessClose()}>
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`}/>
                    </button>
                    <div className="modal-success-container">
                        <img className="modal-success-image" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/icon-success.svg`}/>
                        <div className="modal-success-title">Thank You!</div>
                        <div className="modal-success-text">Your request was successfully sent</div>
                        <Link className="modal-success-btn button-gradient" onClick={() => modalSuccessClose()} to="/">Back to the Home page</Link>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default JobInfo;

